var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 20 20",
        width: "20",
        height: "20",
      },
    },
    [
      _c("path", {
        attrs: {
          d:
            "M10 0C5.862 0 2.5 3.125 2.5 6.875 2.5 12.525 10 20 10 20s7.5-7.475 7.5-13.125C17.5 3.125 14.137 0 10 0zm0 18.188C7.675 15.65 3.75 10.55 3.75 6.874c0-3.1 2.813-5.625 6.25-5.625 1.675 0 3.262.6 4.45 1.7 1.15 1.075 1.8 2.462 1.8 3.925 0 3.675-3.925 8.775-6.25 11.313zm2.5-11.313c0 1.387-1.113 2.5-2.5 2.5s-2.5-1.113-2.5-2.5c0-1.388 1.113-2.5 2.5-2.5s2.5 1.112 2.5 2.5z",
          fill: "#999",
          "fill-rule": "evenodd",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }